import React from "react";

/**
 * @component DropboxIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <DropboxIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DropboxIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="DropboxIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M2 7.2l5 3.19 5-3.19L7 4 2 7.2m10 0l5 3.19 5-3.19L17 4l-5 3.2M2 13.55l5 3.19 5-3.19-5-3.2-5 3.2m15-3.2l-5 3.2 5 3.19 5-3.19-5-3.2M7.03 17.8l5.01 3.2 5-3.2-5-3.19-5.01 3.19z"
        fillRule="evenodd"
      />
    </svg>
  )
);
DropboxIcon.displayName = "DropboxIcon";
export default DropboxIcon;
